<div class="p-d-flex p-flex-column p-ai-center gap-6">
  <div>
    Dostupna je nova verzija aplikacije. Morate se ponovo prijaviti kako biste nastavili sa radom.
  </div>
</div>
